import { useReactTable, getCoreRowModel, createColumnHelper } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import { DISPLAY_DATE_WITH_TIME } from "@constants/date-formats";
import { resources } from "@constants/hardcoded-strings";
import { VERIFICATION_SERVICES_DETAILS_URL } from "@constants/routes";
import { FormattedDashboardVerificationService } from "@idw-types/data/dashboard";
import { formatDateToString } from "@utils/date-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { IdwTableContainer } from "../../common/idw-table-container/idw-table-container";
import { IdwTable } from "../../common/idw-table/idw-table";
import styles from "./dashboard-verification-services-table-container.less";
import { useMemo } from "react";

type DashboardVerificationServicesTableContainerProps = {
    canListRPServices: boolean;
    verificationServices: Array<FormattedDashboardVerificationService>;
};

export const DashboardVerificationServicesTableContainer = (props: DashboardVerificationServicesTableContainerProps) => {
    const { canListRPServices, verificationServices } = props;

    const columnHelper = createColumnHelper<FormattedDashboardVerificationService>();

    const columns = useMemo(() => ([
        columnHelper.accessor("serviceName", {
            header: resources.tables.dashboardVerificationServices.columns.serviceName.header,
            cell: (props) => canListRPServices ? (
                <Link className={styles.link} to={injectRpServiceId(VERIFICATION_SERVICES_DETAILS_URL, props.row.original.rpServiceID)}>
                    {props.getValue()}
                </Link>
            ) : <span>{props.getValue()}</span>
        }),
        columnHelper.accessor("serviceType", {
            header: resources.tables.dashboardVerificationServices.columns.serviceType.header,
            cell: (props) => props.getValue() ? <span>{props.getValue().value}</span> : null
        }),
        columnHelper.accessor("changeRequestStatus", {
            header: resources.tables.dashboardVerificationServices.columns.changeRequestStatus.header
        }),
        columnHelper.accessor("changeRequestDate", {
            header: resources.tables.dashboardVerificationServices.columns.date.header,
            cell: (props) => props.getValue() ? <span>{formatDateToString(props.getValue(), DISPLAY_DATE_WITH_TIME)}</span> : null
        })
    ]), [verificationServices]);

    const useTableResult: any = useReactTable({
        columns,
        data: verificationServices,
        getCoreRowModel: getCoreRowModel(),
        filterFns: null,
        sortDescFirst: false,
        enableSorting: false
    });

    return (
        <IdwTableContainer>
            <IdwTable
                id="dashboard-verification-services"
                useTableResult={useTableResult}
                headerColumnKeyPrefix={"dashboard-verification-services"}
            />
        </IdwTableContainer>
    );
};